import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import {
  GET_CURRENT_USER_SUCCESS,
  GET_USERS_SUCCESS,
  GetCurrentUserAction,
  GetUsersAction,
  GetUsersStatsAction
} from './users.action';
import { IState } from '../shared/models/state';
import {NgxPermissionsService} from "ngx-permissions";


@Injectable()
export class UsersResolve implements Resolve<any> {
  result: any;
  constructor(private store: Store<IState>, private action$: Actions, private ngxPermissionsService: NgxPermissionsService) {}

  async resolve() {
    this.ngxPermissionsService.hasPermission('EDIT_USER_PERMISSION').then((result) => {
      if(result) {
        this.store.dispatch(new GetUsersStatsAction());
        this.store.dispatch(new GetUsersAction());
        this.result =  this.action$.ofType(GET_USERS_SUCCESS).take(1);
      } else {
        this.store.dispatch(new GetCurrentUserAction());
        this.action$.ofType(GET_CURRENT_USER_SUCCESS).take(1);
      }
    });
  }
}
